'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getGlobalGroupElements, getGlobalPartialElements, getEmbedElements } from 'InpageEditorUI/lib/inpage/utils';
import { getHasContentEmbedAccess, getHasGlobalContentEditorAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { updateSelectedItem, clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { openConfirmEditGlobal, openConfirmEditEmbed } from 'ContentEditorUI/redux/actions/appActions';
import { HIGHLIGHTED_CLASS } from 'InpageEditorUI/lib/dom';
import { DraggableSectionTypes } from './sidebar/sections/InpageDraggableSection';
const mapStateToProps = state => {
  return {
    hasContentEmbedAccess: getHasContentEmbedAccess(state),
    hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state)
  };
};
const mapDispatchToProps = {
  openConfirmEditGlobal,
  openConfirmEditEmbed,
  clearSelectedItem,
  updateSelectedItem
};
class GlobalContentEditor extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = () => {
      const {
        selectedItemId,
        globalGroup,
        hasContentEmbedAccess,
        hasGlobalContentEditorAccess,
        type
      } = this.props;
      if (!selectedItemId) {
        const isEmbed = type === DraggableSectionTypes.EMBED;
        if (isEmbed && hasContentEmbedAccess) {
          this.props.openConfirmEditEmbed(globalGroup.id);
        } else if (hasGlobalContentEditorAccess) {
          this.props.openConfirmEditGlobal(globalGroup.path);
        }
      }
    };
  }
  componentDidMount() {
    this.globalGroupElements.forEach((elem, i) => {
      elem.setAttribute('data-global-group-instance', i);
      elem.classList.add('hs-baymax-editor');
      elem.addEventListener('click', this.handleClick);
    });
  }
  componentDidUpdate(prevProps) {
    const {
      globalGroup,
      highlightedWidgetId
    } = this.props;
    if (prevProps.highlightedWidgetId !== highlightedWidgetId) {
      if (prevProps.highlightedWidgetId === globalGroup.path) {
        this.globalGroupElements.forEach(elem => {
          elem.classList.remove(HIGHLIGHTED_CLASS);
        });
      } else if (highlightedWidgetId === globalGroup.path) {
        this.globalGroupElements.forEach(elem => {
          elem.classList.add(HIGHLIGHTED_CLASS);
        });
      }
    }
  }
  componentWillUnmount() {
    this.globalGroupElements.forEach(elem => {
      elem.removeEventListener('mousedown', this.handleClick);
    });
  }
  get stringId() {
    const {
      globalGroup
    } = this.props;
    return `${globalGroup.id}`;
  }
  get globalGroupElements() {
    const {
      globalGroup,
      type
    } = this.props;
    switch (type) {
      case 'group':
        // Wrap with Array.from so that IE11 doesn't break when calling .forEach
        return Array.from(getGlobalGroupElements(globalGroup.path));
      case 'partial':
        return Array.from(getGlobalPartialElements(globalGroup.path));
      case 'embed':
        return Array.from(getEmbedElements(globalGroup.id));
      default:
        return [];
    }
  }
  render() {
    return null;
  }
}
GlobalContentEditor.propTypes = {
  openConfirmEditGlobal: PropTypes.func.isRequired,
  openConfirmEditEmbed: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string,
  globalGroup: PropTypes.object.isRequired,
  hasContentEmbedAccess: PropTypes.bool.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired,
  highlightedWidgetId: PropTypes.string,
  type: PropTypes.string.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(GlobalContentEditor);